<template>
  <div class="title text-center mt-4 mb-6">
    {{$t('Добавить')}}
  </div>
  <ComponentChooser :blockId="props.blockId" :componentUniqueId="props.componentUniqueId" :order="props.order" />
  <div class="missing-block-btn text-center cursor-pointer" @click="openMissingBlockForm">
    {{ $t('Не нашли нужный блок?') }}
  </div>
  
</template>

<script setup lang="ts">

import ComponentChooser from "@/components/ComponentChooser.vue";
import MissingBlockForm from "@/components/dialogs/MissingBlockForm.vue";
import {useDialogStore} from "@/stores/dialogStore";

const dialogStore = useDialogStore()

const props = defineProps({
  blockId: { type: Number },
  componentUniqueId: { type: String },
  order: { type: Number }
});

function openMissingBlockForm() {
  dialogStore.open(MissingBlockForm)
}

</script>

<style scoped lang="sass">
.title
  color: #363636
  font-size: 20px
  font-weight: 600
  line-height: normal

.missing-block-btn
  color: #6C757D
  font-size: 14px
  line-height: normal
  padding: 16px
</style>
